<template>
  <div>
    <p>Are you more of an architect, mechanic or mad-scientist?</p>
    <p>With an entire LEGO Universe to customize and co-create, which type of model will you make the most?</p>
    <poll-images id="3c0ac4bd-8090-4d85-812b-e4d41a4aab39"></poll-images>
    <poll id="3c0ac4bd-8090-4d85-812b-e4d41a4aab39"></poll>
  </div>
</template>
